import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./loading-large.svg?react";

export const LoadingLargeIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
